import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import Table from "./Components/Table";
import { useDispatch, useSelector } from "react-redux";
import { getClassList, getSectionList, getStudentList, managementKidList } from "../../redux/actions/student";
import { setFilters } from "../../redux/actions/dashboard";
import { KID_FILTER } from "../../redux/actions/types";
import Filters from "../Home/Components/Filters";
import { kidActiveFilter } from "../../helper/general";

const StudentManagement = () => {

  const dispatch = useDispatch();

  const kidFilter = useSelector(state => state.student.kidFilter);
  const studentList = useSelector(state => state.student.list);
  const kidList = useSelector(state => state.student.kidList)

  const [activePage, setActivePage] = useState(1);
  const [reload, setReload] = useState();

  var studentNameList = kidList?.data?.reduce((obj, item) => Object.assign(obj, { [item.id]: item.name }), {});
  const additionalFilter = { "Student Name": { ...studentNameList } }

  useEffect(() => {
    dispatch(getClassList());
    dispatch(getSectionList());
  }, [])

  useEffect(() => {
    dispatch(getStudentList({ ...kidFilter, pageNo: (activePage - 1), pageSize: 10 }));
  }, [reload])

  const handlePageChange = (pageNumber) => {
    const page = pageNumber - 1;
    setActivePage(pageNumber);
    dispatch(getStudentList({ ...kidFilter, pageNo: page, pageSize: 10 }));
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target
    const data = { ...kidFilter }
    const index = data[name]?.indexOf(parseInt(value));
    if (index >= 0) {
      data[name].splice(index, 1)
    } else {
      data[name].push(parseInt(value));
    }
    dispatch(setFilters(KID_FILTER, data));
    setActivePage(1);
    dispatch(getStudentList({ ...data, pageNo: 0, pageSize: 10 }));
  }

  const handleStudentSearch = e => {
    const { name, value } = e.target;
    if (kidFilter?.kidIds?.length) {
      dispatch(setFilters(KID_FILTER, { ...kidFilter, kidIds: [] }));
      const currentFilter = { ...kidFilter, kidIds: [] }
      dispatch(getStudentList({ ...currentFilter, pageNo: 0, pageSize: 10 }));
    }
    if (value.length > 2) {
      dispatch(managementKidList({ ...kidFilter, nameLike: value, pageNo: 0, pageSize: 100 }));
    }
  }

  return (
    <Layout title="Student Managements" page="management">
      <div className="m-top-3"><div className="page-title"><h2>Student Managements</h2></div></div>
      <div className="container-fluid">
        <Filters handleFilterChange={handleFilterChange} filterData={kidFilter} activeFilter={kidActiveFilter} additionalFilter={additionalFilter} additionMethod={handleStudentSearch} />
        <Table data={studentList} activePage={activePage} handlePageChange={handlePageChange} setReload={setReload} />
      </div>
    </Layout>
  );
};

export default StudentManagement;